import { Injectable } from '@angular/core';
import {
    AccessibilityFastTrackRepoService,
} from '@client/app/services/api/accessibility/accessibility-fast-track-repo/accessibility-fast-track-repo.service';


/**
 * Manages stored variables in Fast Track Session
 */
@Injectable({
    providedIn: 'root',
})
export class FastTrackService {
    constructor (private accessibilityFastTrackRepo: AccessibilityFastTrackRepoService) {}

    getFastTrack (id: string) {
        return this.accessibilityFastTrackRepo.get(id);
    }

    getAllChecks (id: string) {
        return this.accessibilityFastTrackRepo.getAllChecks(id);
    }

    markCheckAsFixed (domainId: string, sourceCodeId: string, checkId: string) {
        return this.accessibilityFastTrackRepo.markCheckAsFixed(domainId, sourceCodeId, checkId);
    }

    updateCheck (accId: string, check: any) {
        return this.accessibilityFastTrackRepo.updateCheck(accId, check);
    }
}
